import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"

const LOCALE_REGEX = /^\/[a-z]{2}(\/|$)/

function stripLocale(pathname) {
  return pathname.replace(LOCALE_REGEX, "/")
}

function ScrollToTop({ children }) {
  const location = useLocation()
  const prevPathname = useRef(location.pathname)

  useEffect(() => {
    const prev = stripLocale(prevPathname.current)
    const curr = stripLocale(location.pathname)
    const onlyLocaleChanged = prev === curr

    prevPathname.current = location.pathname

    if (!location.pathname.includes("configure") && !onlyLocaleChanged) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }, [location.pathname])

  return children
}

export default ScrollToTop
